module.exports = __webpack_public_path__ + "img/smart-city-detail.e52c002d.jpg";